import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Divider} from 'primeng/divider';

@Component({
  selector: 'app-subsection-title',
  imports: [TranslocoPipe, Divider],
  templateUrl: './subsection-title.component.html',
})
export class SubsectionTitleComponent {
  key = input.required<string>();
}
